export class AnalyticsService {
  public static GA4_ID = process.env.NEXT_PUBLIC_GA4_ID;
  public static LISTING_FB_ID = process.env.NEXT_PUBLIC_LISTING_FACEBOOK_APP_ID;
  public static PARTNERS_FB_ID =
    process.env.NEXT_PUBLIC_PARTNERS_FACEBOOK_APP_ID;
}
